export const generateLegendImageComponent =
	(folder, publicPath = "assets/images/legend") =>
	({ fileName, alt, imgProps = {} }) =>
		<img src={`${publicPath}/${folder}/${fileName}`} alt={alt} {...imgProps} />;
